import { isBrowser } from './is-browser.util';

export function openExternalUrl(url: string, isNewPage = true): void {
  if (!isBrowser()) return;
  isNewPage ? window.open(url, '_blank') : (window.location.href = url);
}
